module.exports = __webpack_public_path__ + "img/188.848fe3a1.jpg";